export const SET_STRIPE_API_KEY = "SET_STRIPE_API_KEY";